const currencies = {
  AED: 'dirham de los Emiratos Árabes Unidos',
  AFN: 'afgani afgano',
  ALL: 'lek albanés',
  AMD: 'dram armenio',
  ANG: 'florín de las Antillas Neerlandesas',
  AOA: 'kwanza angoleño',
  ARS: 'peso argentino',
  AUD: 'dólar australiano',
  AWG: 'florín arubeño',
  AZN: 'manat azerbaiyano',
  BAM: 'marco convertible de Bosnia y Herzegovina',
  BBD: 'dólar de Barbados',
  BDT: 'taka de Bangladesh',
  BGN: 'lev búlgaro',
  BHD: 'dinar bahreiní',
  BIF: 'franco burundés',
  BMD: 'dólar de Bermudas',
  BND: 'dólar de Brunei',
  BOB: 'boliviano',
  BRL: 'real brasileño',
  BSD: 'dólar de las Bahamas',
  BTN: 'ngultrum de Bután',
  BWP: 'pula de Botswana',
  BYN: 'rublo bielorruso',
  BZD: 'dólar de Belice',
  CAD: 'dólar canadiense',
  CDF: 'franco congoleño',
  CHF: 'franco suizo',
  CLP: 'peso chileno',
  CNY: 'yuan chino',
  COP: 'peso colombiano',
  CRC: 'colón costarricense',
  CUC: 'peso cubano convertible',
  CUP: 'peso cubano',
  CVE: 'escudo caboverdiano',
  CZK: 'corona checa',
  DJF: 'franco yibutiano',
  DKK: 'corona danesa',
  DOP: 'peso dominicano',
  DZD: 'dinar argelino',
  EGP: 'libra egipcia',
  ERN: 'nakfa de Eritrea',
  ETB: 'birr etíope',
  EUR: 'euro',
  FJD: 'dólar fiyiano',
  FKP: 'libra de las Islas Malvinas',
  GBP: 'libra esterlina',
  GEL: 'lari georgiano',
  GGP: 'libra de Guernsey',
  GHS: 'cedi ghanés',
  GIP: 'libra de Gibraltar',
  GMD: 'dalasi gambiano',
  GNF: 'franco guineano',
  GTQ: 'quetzal guatemalteco',
  GYD: 'dólar guyanés',
  HKD: 'dólar de Hong Kong',
  HNL: 'lempira hondureño',
  HRK: 'kuna croata',
  HTG: 'gourde haitiano',
  HUF: 'florín húngaro',
  IDR: 'rupia indonesia',
  ILS: 'sheqel israelí',
  IMP: 'libra de la Isla de Man',
  INR: 'rupia india',
  IQD: 'dinar iraquí',
  IRR: 'rial iraní',
  ISK: 'corona islandesa',
  JEP: 'libra de Jersey',
  JMD: 'dólar jamaiquino',
  JOD: 'dinar jordano',
  JPY: 'yen japonés',
  KES: 'chelín keniano',
  KGS: 'som kirguís',
  KHR: 'riel camboyano',
  KMF: 'franco comorense',
  KPW: 'won norcoreano',
  KRW: 'won surcoreano',
  KWD: 'dinar kuwaití',
  KYD: 'dólar de las Islas Caimán',
  KZT: 'tenge kazako',
  LAK: 'kip laosiano',
  LBP: 'libra libanesa',
  LKR: 'rupia de Sri Lanka',
  LRD: 'dólar liberiano',
  LSL: 'loti lesothense',
  LYD: 'dinar libio',
  MAD: 'dirham marroquí',
  MDL: 'leu moldavo',
  MGA: 'ariary de Madagascar',
  MKD: 'dinar macedonio',
  MMK: 'kyat de Myanmar',
  MNT: 'tugrik mongol',
  MOP: 'pataca de Macao',
  MRO: 'ouguiya mauritano',
  MUR: 'rupia mauriciana',
  MVR: 'rufiyaa de Maldivas',
  MWK: 'kwacha malauí',
  MXN: 'peso mexicano',
  MYR: 'ringgit malasio',
  MZN: 'metical mozambiqueño',
  NAD: 'dólar namibio',
  NGN: 'naira nigeriana',
  NIO: 'córdoba nicaragüense',
  NOK: 'corona noruega',
  NPR: 'rupia nepalí',
  NZD: 'dólar neozelandés',
  OMR: 'rial omaní',
  PAB: 'balboa panameño',
  PEN: 'sol peruano',
  PGK: 'kina de Papúa Nueva Guinea',
  PHP: 'peso filipino',
  PKR: 'rupia pakistaní',
  PLN: 'zloty polaco',
  PYG: 'guaraní paraguayo',
  QAR: 'rial catarí',
  RON: 'leu rumano',
  RSD: 'dinar serbio',
  RUB: 'rublo ruso',
  RWF: 'franco ruandés',
  SAR: 'rial saudí',
  SBD: 'dólar de las Islas Salomón',
  SCR: 'rupia de Seychelles',
  SDG: 'libra sudanesa',
  SEK: 'corona sueca',
  SGD: 'dólar de Singapur',
  SHP: 'libra de Santa Elena',
  SLL: 'leona de Sierra Leona',
  SOS: 'chelín somalí',
  SRD: 'dólar surinamés',
  SSP: 'libra sursudanesa',
  STD: 'dobra de Santo Tomé y Príncipe',
  SVC: 'colón salvadoreño',
  SYP: 'libra siria',
  SZL: 'lilangeni suazi',
  THB: 'baht tailandés',
  TJS: 'somoni tayiko',
  TMT: 'manat turkmeno',
  TND: 'dinar tunecino',
  TOP: "pa'anga tongano",
  TRY: 'lira turca',
  TTD: 'dólar de Trinidad y Tobago',
  TWD: 'dólar taiwanés',
  TZS: 'chelín tanzano',
  UAH: 'grivna ucraniana',
  UGX: 'chelín ugandés',
  USD: 'dólar estadounidense',
  UYU: 'peso uruguayo',
  UZS: 'som uzbeko',
  VEF: 'bolívar venezolano',
  VND: 'dong vietnamita',
  VUV: 'vatu vanuatuense',
  WST: 'tala samoano',
  XAF: 'franco CFA BEAC',
  XAG: 'plata',
  XAU: 'oro',
  XCD: 'dólar del Caribe Oriental',
  XDR: 'derechos especiales',
};

export const currenciesJSON = Object.keys(currencies).map((key) => ({ code: key, name: currencies[key] }));
